/**
 * Organização e projeto ativos, enviados em toda chamada à API.
 * O backend só aceita organização com vínculo e projeto daquela organização;
 * sem o header de projeto, usa o projeto padrão.
 */
export const TENANT_STORAGE_KEY = 'selected_tenant_id';
export const PROJECT_STORAGE_KEY = 'selected_project_id';

export function scopeHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  try {
    const tenantId = localStorage.getItem(TENANT_STORAGE_KEY);
    const projectId = localStorage.getItem(PROJECT_STORAGE_KEY);
    if (tenantId) headers['X-Tenant-Id'] = tenantId;
    if (projectId) headers['X-Project-Id'] = projectId;
  } catch { /* sem storage */ }
  return headers;
}

/**
 * Rede de segurança: vários componentes montam o fetch à mão só com o token.
 * Acrescenta organização/projeto às chamadas relativas a /api que não os
 * tenham, para nada ser criado ou listado no projeto errado.
 */
export function installScopeHeaders() {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    const isApi = url.startsWith('/api/') || url.startsWith(`${window.location.origin}/api/`);
    if (!isApi || input instanceof Request) return originalFetch(input, init);
    const headers = new Headers(init?.headers);
    if (!headers.has('Authorization')) return originalFetch(input, init);
    for (const [key, value] of Object.entries(scopeHeaders())) {
      if (!headers.has(key)) headers.set(key, value);
    }
    return originalFetch(input, { ...init, headers });
  };
}
